export default __webpack_public_path__ + "static/media/0075.e62de1ef.png";